"use client";
import { AdditiveItem, type TAdditiveSection } from "@/app/additives/page";
import { motion } from "framer-motion";
import { ItemCard } from "./ItemCard";

export function AdditiveSection({ section }: { section: TAdditiveSection }) {
  const itemCardStructuredData = (item: AdditiveItem) => ({
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://sima-asphalt.com",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Equipment",
            item: "https://sima-asphalt.com/equipment",
          },
          {
            "@type": "ListItem",
            position: 3,
            name: item.name,
          },
        ],
      },
    ],
  });
  return (
    <motion.div
      //@ts-ignore
      className="w-full max-w-screen-xl flex flex-col gap-12 items-center"
      key={section.title}
      initial={{ y: 100, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{
        ease: "easeIn",
        delay: 0,
        duration: 0.2,
      }}
    >
      <div className="w-full">
        <h2 className="text-3xl text-sima-orange font-sans font-bold mx-auto w-full self-start inline-flex ">
          {section.title}
        </h2>
        {section.description && section.description.length > 0
          ? section.description.map((para, idx) => (
              <p key={idx} className="text-xl md:text-2xl font-light">
                {para}
              </p>
            ))
          : null}
      </div>

      {/* there is zero reason for this to be grid, need to re-write this*/}
      <div className="flex items-center   justify-center  w-full mt-auto">
        {section.additives.map((item, idx) => (
          <div className="max-w-[400px] " key={item.name}>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify(itemCardStructuredData(item)),
              }}
              id={`structured-metadata-${idx}`}
            />
            <ItemCard idx={idx} item={item} noMotion cover />
          </div>
        ))}
      </div>
    </motion.div>
  );
}
